import { EMPTY_VALUE } from "@/constants";
import { formatDateToMMDDYYYY } from "@/lib/date-utils";
import { capitalizeInitialLetter } from "@/lib/string-util";
import PersonAvatar from "@/components/custom-ui/person-avatar";

const PcpCard = ({
  firstName,
  lastName,
  visitDate,
  pcpName,
}: {
  firstName: string;
  lastName: string;
  visitDate: Date | undefined;
  pcpName: string | undefined;
}) => {
  return (
    <div className="flex flex-col gap-3 rounded border px-3 py-4">
      <h3 className="text-medium font-medium">{`${firstName} ${lastName}`}</h3>
      <div className="flex w-full justify-between">
        <title>
          {firstName}
          {lastName}
        </title>
        <div className="flex items-start gap-4">
          <PersonAvatar
            firstName={pcpName?.split(" ")[0]}
            lastName={pcpName?.split(" ").slice(-1)[0]}
            imageSrc="/avatar.png"
          />
          <div className="space-y-1">
            <p className="text-sm font-medium leading-none">
              {!pcpName ? EMPTY_VALUE : capitalizeInitialLetter(pcpName)}
            </p>
            <p className="text-sm text-muted-foreground">
              Last Visit:{" "}
              {!visitDate ? EMPTY_VALUE : formatDateToMMDDYYYY(visitDate)}
            </p>
          </div>
        </div>
        {/* <Button variant="link">
          <ChevronRight />
        </Button> */}
      </div>
    </div>
  );
};

export default PcpCard;
